/**
 * @desc 导出物流开票记录
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportTrackKpReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackKpReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
